import { VarianceRequest } from "../model";

export class VarianceStartCommand{
    message:VarianceRequest;

    constructor(message:VarianceRequest){
        this.message = message;
    }   
}